import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import atomize from '@quarkly/atomize';

var Map = function Map(_ref) {
  var _ref$query = _ref.query,
      query = _ref$query === void 0 ? 'New York' : _ref$query,
      _ref$apiKey = _ref.apiKey,
      apiKey = _ref$apiKey === void 0 ? 'AIzaSyA1TA1w9GrLZNaSfAZDaW0lfvGOiL7KULc' : _ref$apiKey,
      props = _objectWithoutProperties(_ref, ["query", "apiKey"]);

  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("iframe", {
    style: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0
    },
    frameBorder: "0",
    allowFullScreen: true,
    src: "https://www.google.com/maps/embed/v1/place?key=".concat(apiKey, "&q=").concat(query)
  }));
};

var GoogleMap = atomize(Map)({
  name: 'GoogleMap',
  propInfo: {
    apiKey: {
      control: 'input',
      category: 'Main'
    },
    query: {
      control: 'input',
      category: 'Main'
    }
  }
}, {
  width: '100%',
  height: '450px',
  position: 'relative'
});
export default GoogleMap;